import * as React from 'react';
import axios from 'axios'
import { url } from '../../weburl';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import ListSubheader from '@mui/material/ListSubheader';
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';
import moment from 'moment';
// import InfoIcon from '@mui/icons-material/Info';

const default_name = 'Unnamed'

export default function NewlyImageGallery(props)
{
    const [newDogs, setnewDogs] = React.useState([])
    const [numberOfNewDogs, setNumberOfNewDogs] = React.useState(0)
    
    React.useEffect(()=>{
        axios
        .get(`${url}api/dogs/s2/newly_registered_dogs`)
        .then((res) =>
        {
            setnewDogs(res.data.newDogs)
            setNumberOfNewDogs(res.data.number_of_new_dogs)
            
        }
        )
        .catch((err) => console.log(err))

    }, [])
        
    


    return (
        <ImageList sx={{ width: "auto", height: "auto" }}>
            <ImageListItem key="Subheader" cols={2}>
                <ListSubheader component="div" className='bg-light border-dark'>
                    <span className='font-weight-bold'>{numberOfNewDogs} </span>newly registered dogs</ListSubheader>
            </ImageListItem>
            {newDogs.map((item) => (
                <ImageListItem key={item.id}>
                    <img
                        src={`https://res.cloudinary.com/daurieb51/image/upload/v1659038540/${item.public_id}?w=248&fit=crop&auto=format`}
                        srcSet={`https://res.cloudinary.com/daurieb51/image/upload/v1659038540/${item.public_id}?w=248&fit=crop&auto=format&dpr=2 2x`}
                        alt={item.name}
                        loading="lazy"
                    />
                    <ImageListItemBar
                        title={item.name}
                        subtitle={moment(item.date_registered).fromNow()}
                        sx={{fontWeight:'bold'}}
                        className='smallrem'
                        actionIcon={
                            <IconButton
                                sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                aria-label={`info about ${item.name}`}
                            >
                                {/* <InfoIcon /> */}
                            </IconButton>
                            
                        }
                    />
                </ImageListItem>
            ))}
        </ImageList>
    );
}

